// eslint-disable-next-line func-names
(function() {
  let mediaQuery = window.matchMedia("(max-width: 64em)");
  if ( mediaQuery.matches) {
    let content_panel_titles = document.querySelectorAll(".nested-accordion-content-panel-title");
    let content_item_titles = document.querySelectorAll(".nested-accordion-content-item-title");
    let first_item = document.querySelector(".nested-accordion-item-content");
    first_item.style.display = "block";
    //this is so that the first entry which is open and displays by defualt has the correct icon
    let first_category_title_icon = document.querySelector(".nested-accordion-icon-mobile");
    first_category_title_icon.classList.add('active');


    content_panel_titles.forEach((panel_title) => {
      panel_title.addEventListener("click", switchMobilePanel);
    });

    content_item_titles.forEach((item_title) => {
      item_title.addEventListener("click", switchMobileItem);
    });

    function switchMobilePanel(e) {
      let panel;
      //doing this so that when the child element that hold the + icon is clicked the panel still changes.
      if (e.target.className == "nested-accordion-icon-mobile") {
        panel = e.target.parentNode;
      } else {
        panel = e.target;
      }
      let content_panels_titles = document.querySelectorAll(".nested-accordion-content-panel-title");

      content_panels_titles.forEach(cp => {
        if (panel.id == cp.id) {
          let siblings = cp.parentNode.childNodes;
          siblings.forEach(sibling => {
            if (sibling.classList.contains("nested-accordion-content-panel-title")) {
              sibling.children[0].classList.add('active');
            } else if (sibling == siblings[1]) {
              sibling.style.display = 'block';
              sibling.children[0].style.display = 'block';
              sibling.children[1].style.display = 'block';
            } else {
              sibling.style.display = 'block';
              sibling.children[0].style.display = 'block';
              sibling.children[1].style.display = 'none';
            }
          });
        } else {
          let siblings =  cp.parentNode.childNodes;
          siblings.forEach(sibling => {
            if (sibling.classList.contains("nested-accordion-content-panel-title")) {
              sibling.children[0].classList.remove('active');
            } else {
              sibling.style.display = 'none';
            }
          });
        }
      })
    }

    function switchMobileItem(e) {
      let item_title = e.target;
      let all_item_titles = document.querySelectorAll(".nested-accordion-content-item-title");

      all_item_titles.forEach(title => {
        if (title == item_title) {
          item_title.nextElementSibling.style.display = "block";
        } else {
          title.nextElementSibling.style.display = "none";
        }
      });
    }

  } else {
    let category_title_list = document.querySelectorAll(".nested-accordion-category-title");
    let category_item_list = document.querySelectorAll(".nested-accordion-category-item");
    let first_category_entry = document.querySelector(".nested-accordion-category-item");
    let first_category_title_icon = document.querySelector(".nested-accordion-icon");
    //this is so that the first entry which is open and displays by defualt has the correct background
    first_category_entry.style.backgroundColor = "#e8e8e8";
    first_category_title_icon.classList.add('active');

    category_title_list.forEach((category_title) => {
      category_title.addEventListener("click", swtichCategory);
    });

    category_item_list.forEach((category_item) => {
      category_item.addEventListener("click", swtichContentItem);
    });

    category_title_list.forEach((category_title) => {
      category_title.addEventListener("keydown", (event) => {
        if (event.code === 'Enter') {
          category_title.click();
        }
      });
    });

    category_item_list.forEach((category_item) => {
      category_item.addEventListener("keydown", (event) => {
        if (event.code === 'Enter') {
          category_item.click();
        }
      });
    });

    function swtichCategory(e) {
      let category;
      //doing this so that when the child element that hold the + icon is clicked the panel still changes.
      if (e.target.className == "nested-accordion-icon") {
        category = e.target.parentNode;
      } else {
        category = e.target;
      }

      let content_panels = document.querySelectorAll(".nested-accordion-content-panel-container");
      let category_parent = category.parentNode;
      let category_items = document.querySelectorAll(".nested-accordion-category-item");
      let category_title_list = document.querySelectorAll(".nested-accordion-category-title");
      //swtiching the panels that show and making sure the panel titles shows
      //becuase we hide it when it closes so that when you re-open the panel you don't see the old
      //open content'
      content_panels.forEach(panel => {
        if (panel.id == category.id) {
          panel.style.display = 'block';
          panel.childNodes[0].style.display = "block";
          panel.childNodes[1].style.display = "block";
        } else {
          panel.style.display = 'none';
          panel.childNodes.forEach(child =>{
            child.style.display = "none";
          });
        }
      });

      //when switching categories we want to un-gray the category items and
      //gray the first item by defualt when it opens.
      category_items.forEach(item => {
        if (item.parentNode == category_parent && item == category_parent.childNodes[1]) {
          item.style.display = "grid";
          item.style.backgroundColor = "#e8e8e8";
        } else if (item.parentNode == category_parent) {
          item.style.display = "grid";
          item.style.backgroundColor = "white";
        } else {
          item.style.display = "none";
          item.style.backgroundColor = "white";
        }
      });

      //this is to change the little icon + to a - and back again on close
      category_title_list.forEach(title => {
        if (title == category) {
          let icon = category.childNodes[1];
          icon.classList.add('active');
        } else {
          let icon = title.childNodes[1];
          icon.classList.remove('active');
        }
      })
    } //end swtichCategory

    function swtichContentItem(e) {
      let category_item = e.target;
      let content_items = document.querySelectorAll(".nested-accordion-content-panel");
      let category_parent = category_item.parentNode;

      //gray teh background of the selected category and show the related content item in the panel
      content_items.forEach(item => {
        if (item.id == category_item.id) {
          item.style.display = "block";
          category_item.style.backgroundColor = "#e8e8e8";
        } else {
          item.style.display = "none";
        }
      });

      //change the background color of the non-selected categories to white
      category_parent.childNodes.forEach(child => {
        if (child != category_parent.firstChild && child != category_item) {
          child.style.backgroundColor = "white";
        }
      });
  }
} //end else from mediaQuery
///////////////////////////////////////////////////////////////////////////////
    //rating system here
  let like_buttons = document.querySelectorAll('.like_radio_input');
  let dislike_buttons = document.querySelectorAll('.dislike_radio_input');

  function likeRadio(e) {
    let like = e.target;
    let dislike = like.parentNode.parentNode.nextElementSibling;
    let comment_label = dislike.nextElementSibling.children[0];
    let submit_button = dislike.parentNode.lastElementChild.children[0];

    dislike.children[1].children[0].checked = false;
    comment_label.innerHTML = "Comment (optional)";
    submit_button.classList.remove('is-disabled');
    submit_button.disabled = false;
  } // end likeRadio

  function dislikeRadio(e) {
    let dislike = e.target;
    let like = dislike.parentNode.parentNode.previousElementSibling;
    let comment_label = dislike.parentNode.parentNode.nextElementSibling.children[0];
    let submit_button = dislike.parentNode.parentNode.parentNode.lastElementChild.firstElementChild;
    let comment_textarea = dislike.parentNode.parentNode.nextElementSibling.children[1].children[0];
    like.children[1].children[0].checked = false;
    comment_label.innerHTML = "Comment (required)";

    if (comment_textarea.value.length < 1) {
      submit_button.disabled = true;
      submit_button.classList.add('is-disabled');
    } else if (comment_textarea.value.length > 1) {
      submit_button.disabled = false;
      submit_button.classList.remove('is-disabled');
    }

  } // end dislikeRadio

  like_buttons.forEach((like_button) => {
    like_button.addEventListener("click", likeRadio);
  });

  dislike_buttons.forEach((dislike_button) => {
    dislike_button.addEventListener("click", dislikeRadio);
  });

  let comment_textareas = document.querySelectorAll('.raa-module-rating-text');

  comment_textareas.forEach((comment_textarea) => {
    comment_textarea.addEventListener('input', updateCounter);
  });

  function updateCounter(e) {
    let comment_textarea = e.target;
    let currentLength = comment_textarea.value.length;
    let maxLength = parseInt(comment_textarea.getAttribute('maxlength'));
    let submit_button = comment_textarea.parentNode.parentNode.parentNode.lastElementChild.firstElementChild;
    let text_counter = comment_textarea.parentNode.parentNode.nextElementSibling;
    let remaining_chars = 128 - currentLength;
    let like_button = comment_textarea.parentNode.parentNode.parentNode.children[3].children[1].children[0];
    let dislike_button = comment_textarea.parentNode.parentNode.parentNode.children[4].children[1].children[0];
    text_counter.textContent = remaining_chars + " characters remaining";
    if (like_button.checked) {
      submit_button.classList.remove('is-disabled');
      submit_button.disabled = false;
    } else if (dislike_button.checked && comment_textarea.value.length > 1) {
      submit_button.classList.remove('is-disabled');
      submit_button.disabled = false;
    } else {
      submit_button.classList.add('is-disabled');
      submit_button.disabled = true;
    }
  }

})();
